import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { apiLoginHistoryList } from 'Services/AdminService'
import { getFinancialYearDates } from 'Utils/helper'

export const getData = createAsyncThunk('admin/loginHistory/getData', async datas => {
    const { data } = await apiLoginHistoryList(datas)
    return data
})

export const loginHistorySlice = createSlice({
    name: 'admin/loginHistory',
    initialState: {
        loading: true,
        data: [],
        total: 0,
        table: {
            page: 1,
            length: 10,
            search: '',
            column: 'created_at',
            dir: 'desc',
            ...getFinancialYearDates(),
        },
    },
    reducers: {
        setData: (state, { payload }) => {
            state.data = payload
        },
        setTableData: (state, { payload }) => {
            state.table = payload
        },
        setDate: (state, { payload: { start, end } }) => {
            state.table.page = 1
            state.table.start = start
            state.table.end = end
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getData.pending, state => {
                state.loading = true
            })
            .addCase(getData.fulfilled, (state, { payload }) => {
                state.loading = false
                state.data = payload.data
                state.total = payload.total
            })
            .addCase(getData.rejected, state => {
                state.loading = false
                state.data = []
                state.total = 0
            })
    },
})

export const { setData, setTableData, setDate } = loginHistorySlice.actions

export default loginHistorySlice.reducer
